import type { WebGrpcDecodedData } from '@terra/shared-schemas-tracker';
import {
  buildGrpcHarPreviewDecodePayload,
  isGrpcHarEntry,
  type StoredHarDisplayEntry,
} from '@terra/shared-utils';
import { portalDecodeGrpcHarApi } from '../clients/tester-client/portal/portal-decode-grpc-har-api';

export {
  hasAnyUsableGrpcHarDecode,
  hasUsableRequestWebGrpcDecode,
  hasUsableResponseWebGrpcDecode,
  isGrpcHarDecodeComplete,
  isGrpcHarEntry,
  mergeWebGrpcDecodedData,
} from '@terra/shared-utils';

type GrpcHarEntryShape = StoredHarDisplayEntry;

export const buildStoredHarDisplayEntry = (
  harEntry: GrpcHarEntryShape,
): StoredHarDisplayEntry | undefined => {
  if (!isGrpcHarEntry(harEntry) && !harEntry.webGrpcDecodedData) {
    return undefined;
  }

  return {
    request: harEntry.request,
    response: harEntry.response ?? null,
    webGrpcDecodedData: harEntry.webGrpcDecodedData ?? null,
  };
};

export const hasGrpcHarHistoryEntry = ({
  grpcHarDisplay,
}: {
  grpcHarDisplay?: StoredHarDisplayEntry;
  hasDecodedBodyView?: boolean;
}): boolean => {
  if (!grpcHarDisplay) {
    return false;
  }

  return isGrpcHarEntry(grpcHarDisplay);
};

export async function fetchGrpcHarPreviewDecode({
  applicationId,
  harEntry,
  enabled = true,
}: {
  applicationId: string;
  harEntry: StoredHarDisplayEntry;
  enabled?: boolean;
}): Promise<WebGrpcDecodedData | null> {
  if (!enabled || !isGrpcHarEntry(harEntry)) {
    return null;
  }

  const { webGrpcDecodedData } = await portalDecodeGrpcHarApi.preview(
    buildGrpcHarPreviewDecodePayload({ applicationId, harEntry }),
  );

  return webGrpcDecodedData ?? null;
}
